import React from 'react';
import PropTypes from 'prop-types';
import FormField from './FormField';
import QuickUpdatableComponent from './QuickUpdatableComponent';

class Radio extends QuickUpdatableComponent {
    render() {
        const {required, field, help, options, label, disabled, loading, style} = this.props;
        return (
            <FormField required={required} field={field} help={help} loading={loading} label={label}>
                {options.map((option, index) => {

                 let value = option.label;
                 if (option.value) {
                    value = option.value;
                 }

                 return (
                    <label className="radio-inline"
                           style={style}
                           key={value + '_key'}>
                        <input {...field}
                               type="radio" 
                               id={field.name}
                               value={value}
                               disabled={disabled}
                               key={value + '_key'}
                               checked={field.value === value ? 'checked' : ''}/> {option.label}
                    </label>
                )})}
          </FormField>);
    }
}

Radio.propTypes = {
    field: PropTypes.object.isRequired
}

export default Radio;
